import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { NotFoundPage } from '../components/common/NotFoundPage';
import { GettingStarted } from '../onboarding/GettingStarted';
import { TourProvider } from '../onboarding/TourProvider';

interface MyRouterContext {
  auth: {
    isAuthenticated: boolean;
    user: any;
  };
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <TourProvider>
      <Outlet />
      <GettingStarted />
    </TourProvider>
  ),
  notFoundComponent: NotFoundPage,
});
